import template from './operation-tasks.html';
import controller from './operation-tasks.controller';

const operationTasksComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default operationTasksComponent;
